export default function SettingsSubSection({ id, title, children }: { id?: string; title: string; children?: React.ReactNode }) {
    return (
        <div className="pt-2 d-flex flex-column gap-2" id={id}>
            <div className="border-bottom fw-semibold">{title}</div>
            <div className="pt-1">
                <div className="d-flex flex-column gap-2">{children}</div>
            </div>
        </div>
    );
}
